import { useLanguage } from "../i18n";
export function PayslipTaskNotice({ pending, disputed, onOpen }: { pending: number; disputed: number; onOpen: () => void }) {
  const { t } = useLanguage();
  if (!pending && !disputed) return null;
  return <div className="service-task-reminder" role="status"><span>{[pending ? t(`您有 ${pending} 份工资条待确认`, `You have ${pending} payslips to review`) : "", disputed ? t(`${disputed} 份工资条异议待财务处理`, `${disputed} payslip concerns need finance attention`) : ""].filter(Boolean).join("；")}</span><button className="button secondary" onClick={onOpen}>{t("查看工资条", "Open payslips")}</button></div>;
}
